module.exports = __webpack_public_path__ + "static/media/ssgandhy.894ef0fc.png";